import styled from '@emotion/styled';

interface FileInputDivProps {
  isFile?: boolean; // Define the custom prop here
}

export const PaymentAutoPostWrapper = styled.div`
  width: 100%;
`;

export const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

export const FileInputWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;

export const FileInputDiv = styled.div<FileInputDivProps>`
  width: 65%;
  display: flex;
  font-size: 0.875rem;
  border: 1px solid #ccc;
  padding-left: 10px;
  border-radius: 8px 0px 0px 8px;
  font-weight: 500;
  align-items: center;
  height: 40px;
  color: ${props => (props?.isFile ? '#000000' : '#ccc')};
`;

export const FileInputText = styled.span`
  width: 85%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;

export const UploadAndSummaryContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

export const UploadContainer = styled.div`
`;

export const SummaryTableContainer = styled.div`
  width: 100%;
`;

export const DateSelectorWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
`;

export const DateSelectorFrom = styled.div`
  display: flex;
  align-items: center;
  margin-right: 20px;
`;

export const DateSelectorTo = styled.div`
  display: flex;
  align-items: center;
`;

export const AcceptedTransactionsRefreshContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 1rem 0 1rem 0;
`;

export const FlexContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const FlexGridCell = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: 100%;       
`;
